import { Branch } from 'features/Branch'
import { atom } from 'recoil'

export const branchEditState = atom<Branch | undefined>({
  key: 'branchEditState',
  default: undefined,
})
